$mol_view_tree2_to_js_test_ex_right_in_left_foo $mol_object
	a null
$mol_view_tree2_to_js_test_ex_right_in_left_bar $mol_object
	foo <= Cls $mol_view_tree2_to_js_test_ex_right_in_left_foo
		a => b
	pages /
		<= Menu $mol_page
			Title => Menu_title
